<template>
  <v-card flat style="background-color:transparent;">
    <p class="ma-0 pa-0">
      <!-- <span class="subtitle-1">{{ new Date() | moment("dddd, MMMM Do YYYY") }}</span> -->
      <span class="title">{{ new Date() | moment("dddd, MMMM Do YYYY") }}</span>
    </p>
    <p class="ma-0 pa-0">
      <v-divider></v-divider>
      <v-divider></v-divider>
    </p>
    <a
      href="https://www.facebook.com/pages/category/Media-News-Company/WeNewz-332912934271672/"
      target="_blank"
      style="text-decoration: none;"
    >
      <v-btn
        icon
        medium
        outlined
        class="mt-2 ml-1 mr-1"
        :title="$t('navbar.navbarBig.Link to our Facebook page')"
      >
        <v-icon>fab fa-facebook-f</v-icon>
      </v-btn>
    </a>
    <!-- <v-btn
      outlined
      medium
      icon
      class="mt-2 mr-1"
      :title="$t('navbar.navbarBig.Link to our Twitter page')"
    >
      <v-icon>fab fa-twitter</v-icon>
    </v-btn> -->
    <!-- <v-btn
      icon
      outlined
      class="mt-2 mr-1"
      :title="$t('navbar.navbarBig.Link to our Instagram page')"
    >
      <v-icon>fab fa-instagram</v-icon>
    </v-btn> -->
    <!-- <v-btn icon outlined class="mt-2">
      <v-icon>fas fa-question</v-icon>
    </v-btn> -->
  </v-card>
</template>

<script>
// i18n imported
import messages from "../../modules/lang/export";
export default {
  // I18n used
  i18n: { messages }
};
</script>
